import { variables, $ } from './variables';

const cl = e => {
  console.log(e);
};

const ajax = (params, successFunction, errorFunction, ajaxType) => {
  const url = new URL(variables.ajaxURL); // In wordpress the url is defined in the function.php
  if (window.fetch) {
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
    // prettier-ignore
    return fetch(url, {
      headers: {
        'Content-Type': ajaxType === 'json'
          ? 'application/json; charset=utf-8'
          : ajaxType === 'text'
            ? 'charset=utf-8'
            : undefined
      }
    })
      .then(
        response => ajaxType === 'json'
          ? response.json()
          : ajaxType === 'text'
            ? response.text()
            : undefined
      )
      .then(successFunction)
      .catch(errorFunction);
  } else {
    if (window.jQuery) {
      // prettier-ignore
      return $.ajax({ //Backup JQuery sur IE
        dataType: ajaxType === 'json'
          ? 'json'
          : ajaxType === 'text'
            ? 'html'
            : undefined,
        url: url,
        data: params,
        success: successFunction,
        error: errorFunction
      });
    }
  }
};

const makeScrollbar = (element, theme, fade) => {
  let instance = OverlayScrollbars(element, {
    className: theme,
    scrollbars: {
      autoHide: 'leave',
      autoHideDelay: 400
    },
    callbacks: {
      onInitialized: function (e) {
        if (fade === true) {
          let topFade = document.createElement('div');
          topFade.setAttribute('class', 'scroll-topFade');
          topFade.style.opacity = '0';
          let bottomFade = document.createElement('div');
          bottomFade.setAttribute('class', 'scroll-bottomFade');
          element.prepend(topFade, bottomFade);
        }
      },
      onScroll: function (e) {
        element.dataset.scrollposition = this.scroll().position.y;
        if (fade === true) {
          let scroll_y = this.scroll().ratio.y;
          let topFade = element.querySelectorAll('.scroll-topFade')[0];
          let bottomFade = element.querySelectorAll('.scroll-bottomFade')[0];
          if (scroll_y > 0.9) {
            let scroll_y_opacity = 10 - scroll_y * 10;
            bottomFade.style.opacity = scroll_y_opacity;
          }
          if (scroll_y < 0.1) {
            let scroll_y_opacity = scroll_y * 10;
            topFade.style.opacity = scroll_y_opacity;
          }
          if (scroll_y > 0.1 && scroll_y < 0.9) {
            topFade.style.opacity = '1';
            bottomFade.style.opacity = '1';
          }
        }
      }
    }
  });
}

const removeElement = (element) => {
  !!element && element.parentNode.removeChild(element);
}

export { cl, ajax, removeElement };
